export const formatToINRCurrency = (
  amount: number | string,
  showSymbol: boolean = true
): string => {
  const parsedAmount = Number(amount);

  if (isNaN(parsedAmount) || parsedAmount < 0) {
    return showSymbol ? "₹ 0" : "0";
  }

  const formatted = parsedAmount.toLocaleString("en-IN", {
    style: showSymbol ? "currency" : "decimal",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return showSymbol
    ? formatted.replace(/^(\D+)/, "₹ ") // inserts a space after the currency symbol
    : formatted;
};
